import * as React from 'react';
import { renderHelpText } from './renderHelpText';
import { TextInputField } from './TextInputField';
import { PasswordConfirmationField } from './PasswordConfirmationField';
import { PermissionsField } from './PermissionsField';
import { MultipleTextField } from './MultipleTextField';
import { SexField } from './SexField';
import { TimeIntervalField } from './TimeIntervalField';
import { DayOfWeekField } from './DayOfWeekField';
import { FormGroup, IconButton } from '@material-ui/core';
import { FormHelperText, InputLabel, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { AutocompleteTextField } from './AutocompleteTextField';
import { CheckInputField } from './CheckInputField';
import { ComboField } from './ComboField';
import type { ComboFieldOption } from './ComboField';
import { NumberInputField } from './NumberInputField';
import { SwitchField } from './SwitchField';
import { MultiplePaymentsField } from './MultiplePaymentsField';
import { TimeDayIntervalField } from './TimeDayIntervalField';
import { RecurringEventField } from './RecurringEventField';
import { SelectTextField } from './SelectTextField';
import MultipleCheckboxes from './MultipleCheckboxes';
import { CountryPhonePrefixField } from './CountryPhonePrefixField';
import { PhoneNumberField } from './PhoneNumberField';
import { MultiplePhoneNumberField } from './MultiplePhoneNumberField';
import { MultipleStockItemsField } from './MultipleStockItemsField';
import { ExpenseAttachmentsField } from './ExpenseAttachmentsField';
import { DateField } from './DateField';
import { TimeField } from './TimeField';
import ImmutableField from './ImmutableField';
import { PlaceholderTextField } from './PlaceholderTextField';
import type { PlaceholderItem } from './PlaceholderTextField';
import { DOMAttributes, useState } from 'react';
import HelpIcon from '@material-ui/icons/Help';

export type { ComboFieldOption };

export {
    TextInputField,
    PasswordConfirmationField,
    PermissionsField,
    MultipleTextField,
    SexField,
    TimeIntervalField,
    DayOfWeekField,
    AutocompleteTextField,
    CheckInputField,
    ComboField,
    NumberInputField,
    SwitchField,
    MultiplePaymentsField,
    TimeDayIntervalField,
    RecurringEventField,
    SelectTextField,
    MultipleCheckboxes,
    CountryPhonePrefixField,
    PhoneNumberField,
    MultiplePhoneNumberField,
    MultipleStockItemsField,
    ExpenseAttachmentsField,
    DateField,
    TimeField,
    ImmutableField,
    PlaceholderTextField,
};

export type { PlaceholderItem };

export const FormField: React.FC<{
    label?: string | React.ReactElement, 
    error?: string, 
    helpNotes?: string,
    children: React.ReactElement,
    style?: React.CSSProperties,
    formGroupStyle?: React.CSSProperties,
    isCheckBox?: boolean,
    strong?: boolean,
} & DOMAttributes<HTMLDivElement>> = ({
    label = '',
    children,
    helpNotes,
    error,
    style,
    formGroupStyle,
    isCheckBox,
    strong,
    ...remaining
}) => {
    
    const [showHelp, setShowHelp] = useState(false);
    
    return (
        <div style={style}>
            <FormGroup {...remaining} className="formGroup" style={{paddingLeft: isCheckBox ? '1.4rem' : undefined, ...formGroupStyle}}>
                {label && <InputLabel style={{marginTop: isCheckBox ? '0.1rem' : undefined, marginBottom: '0.5rem', display: 'block', overflow: 'visible'}}>
                    {strong ? <b>{label}</b> : label}
                    {helpNotes && <IconButton size="small" onClick={() => setShowHelp(true)}><HelpIcon/></IconButton>}
                </InputLabel>}
                { children }
                { error && <FormHelperText error>{error}</FormHelperText>}
            </FormGroup>

            {(helpNotes?.length &&
                <Dialog open={showHelp} onClose={() => setShowHelp(false)}>
                    <DialogTitle>{label}</DialogTitle>
                    <DialogContent>{renderHelpText(helpNotes)}</DialogContent>
                </Dialog>
            ) || undefined}
        </div>
    )
}
